import { render, staticRenderFns } from "./ItemDateSetting.vue?vue&type=template&id=8bdbce30&scoped=true&lang=pug&"
import script from "./ItemDateSetting.vue?vue&type=script&lang=js&"
export * from "./ItemDateSetting.vue?vue&type=script&lang=js&"
import style0 from "./ItemDateSetting.vue?vue&type=style&index=0&id=8bdbce30&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bdbce30",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDatePicker } from 'vuetify/lib/components/VDatePicker';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VMenu } from 'vuetify/lib/components/VMenu';
installComponents(component, {VDatePicker,VIcon,VMenu})
